import React from "react";

import '@abb/abb-common-ux-react/styles.css';
import "./shared.sass";
import { WithPopup, Popup, Button, Input } from "@abb/abb-common-ux-react";
import { ABB_CLOSE, ABB_PLUS, ABB_CHECK_MARK } from "../../utilities/IconConstants";
import { BUTTON_CONFIRM, MODULE_SAMPLE, BUTTON_CREATE, MODULE_GRADE, MODULE_PRODUCT, BUTTON_CLONE, LABLE_NAME, LABEL_CODEID, INSTRUMENT_NAME_VALIDATION_ERROR, INSTRUMENT_CODE_VALIDATION_ERROR, MODULE_TESTPLAN } from '../../utilities/Constants';
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";

interface ISidebarCreateProperties {
    setName: (val: string) => void;
    inputName: any;
    onActivate: () => void;
    isShowPopup: boolean;
    onSave: (e: any, val: boolean) => void;
    onDeactivate: () => void;
    module?: string;
    setCode?: (val: string) => void;
    inputCode?: any;
    isShowCodeInput?: boolean;
    nameError?: boolean;
    codeError?: boolean;
    isButtonDisabled?: boolean
}

class SidebarCreate extends React.Component<ISidebarCreateProperties> {
    static defaultProps = {
        codeError: false,
        nameError: false
    }
    public render() {
        return (
            <Translation>
                {
                    t =>
                        <div className="text-center cursor my-1">
                            <WithPopup>
                                <div className={this.props.isShowPopup ? "ml-5 float-left" : null}>
                                    {this.props.isShowPopup ?
                                        <div>
                                            <Button
                                                disabled={this.props.isButtonDisabled}
                                                type="primary-blue"
                                                shape="rounded"
                                                text={t(BUTTON_CONFIRM)}
                                                icon={ABB_CHECK_MARK}
                                                className={this.props.isButtonDisabled ? "border" : "border border-primary"}
                                                style={{ width: 110 }}
                                                onClick={() => this.props.onSave(null, true)}
                                            />
                                            <Button
                                                type="discreet-blue"
                                                shape="rounded"
                                                icon={ABB_CLOSE}
                                                className="border border-primary mt-2"
                                                onClick={this.props.onDeactivate}
                                                style={{ marginLeft: 5 }}
                                            />
                                        </div>
                                        :
                                        <div>
                                            <Button
                                                type="discreet-blue"
                                                shape="rounded"
                                                text={t(BUTTON_CLONE) + " " + t(this.props.module)}
                                                icon={ABB_PLUS}
                                                className="border border-primary mt-2 w-75"
                                                onClick={this.props.onActivate}
                                            />
                                        </div>
                                    }
                                </div>
                                <Popup className="popup-align" trigger="controlled" position="bottom center"
                                    show={this.props.isShowPopup}
                                    defaultOpen={false}
                                    closeOnLostFocus={true}
                                    onClose={() => this.props.onDeactivate()}
                                >
                                    <p><Input
                                        // tslint:disable-next-line: no-unused-expression
                                        inputAttributes={{ 'autoFocus': "true" }}
                                        onKeyUp={this.props.module === MODULE_SAMPLE ? (e) => this.props.onSave(e, true) : null}
                                        className={this.props.nameError ? "error-code mt-2" : "mt-2"}
                                        dataType="text"
                                        label={t(this.props.module) + " " + t(LABLE_NAME)}
                                        placeholder={t(LABLE_NAME)}
                                        required={true}
                                        maxLength={250}
                                        value={String(this.props.inputName)}
                                        onValueChange={(val: string) => this.props.setName(val)}
                                        showValidationBarWhenInvalid={this.props.nameError}
                                        description={ this.props.nameError ? this.props.inputName.length ?  t(INSTRUMENT_NAME_VALIDATION_ERROR) : t(CONSTANTS.FIELD_EMPTY_ERROR) : "" }
                                    /></p>
                                    {(this.props.module !== MODULE_SAMPLE && this.props.module !== MODULE_TESTPLAN) || this.props.isShowCodeInput ?
                                        <p><Input
                                            onKeyUp={(e) => this.props.onSave(e, true)}
                                            className={this.props.codeError ? "error-code mt-2" : "mt-2"}
                                            dataType="text"
                                            label={t(LABEL_CODEID)}
                                            placeholder={t(LABEL_CODEID)}
                                            required={true}
                                            maxLength={20}
                                            value={String(this.props.inputCode)}
                                            onValueChange={(val: string) => this.props.setCode(val)}
                                            showValidationBarWhenInvalid={this.props.codeError}
                                            description={this.props.codeError ? this.props.inputCode.length ?  t(INSTRUMENT_CODE_VALIDATION_ERROR) : t(CONSTANTS.FIELD_EMPTY_ERROR) : "" }
                                        /></p>
                                        : null}
                                </Popup>
                            </WithPopup>
                            <div className="clearfix" />
                        </div>
                }
            </Translation>
        );
    }
}

export default SidebarCreate;
